import React, { Component } from "react";
import { Icon } from "antd";

export default class Condition extends Component {
  state = {
    filterSelectedOption: null,
    filterSelectedCondition: null,
    filterSelectedValue: "",
    filterConditionList: null
  };

  /**
   * Retorna o select inicial para criar um filtro
   */
  getInicialSelect = () => {
    const values = this.props.options;

    return (
      <select
        className="ant-input"
        style={{ maxWidth: "220px" }}
        onChange={this.handleInitialChange}
      >
        <option value="0">Selecione</option>

        {values.map(option => (
          <option value={option.key} key={option.key}>
            {option.text}
          </option>
        ))}
      </select>
    );
  };

  /**
   * Retorna um select com as opções de condição
   */
  getConditionSelect = () => {
    const opts = this.state.filterConditionList;

    if (opts == null) return null;

    return (
      <select
        className="ant-input"
        style={{ maxWidth: "220px" }}
        onChange={this.handleConditionChange}
      >
        <option value="0">Selecione</option>

        {opts.map(opt => (
          <option value={opt} key={opt}>
            {this.translateCondition(opt)}
          </option>
        ))}
      </select>
    );
  };

  /** Retorna um campo para o usuário preencher o valor do filtro de acordo com a opção */
  getValueField = () => {
    const selectedCondition = this.state.filterSelectedCondition;

    if (
      selectedCondition == null ||
      selectedCondition == "0" ||
      selectedCondition == 0
    ) {
      return null;
    }

    const option = this.props.options.filter(
      obj => obj.key === this.state.filterSelectedOption
    )[0];

    const inputType = option.type;

    switch (String(inputType).toLocaleLowerCase()) {
      case "date":
        return (
          <input
            type="date"
            className="ant-input"
            onChange={this.handleValueChange}
            value={this.state.filterSelectedValue}
          />
        );
      case "text":
        return (
          <input
            type="text"
            className="ant-input"
            onChange={this.handleValueChange}
            value={this.state.filterSelectedValue}
          />
        );
      case "option":
        // Return select with options
        const options = option.options;

        return (
          <select className="ant-input" onChange={this.handleValueChange}>
            <option value="0">Selecione</option>

            {options.map(opt => (
              <option value={opt.id} key={opt.id}>
                {opt.text}
              </option>
            ))}
          </select>
        );
    }
  };

  /** Value field change */
  handleValueChange = event => {
    const value = event.target.value;

    this.setState(
      {
        filterSelectedValue: value
      },
      () => {
        // Serilize filter infos
        const selectedOption = this.state.filterSelectedOption;
        const selectedValue = this.state.filterSelectedValue;
        const selectedCondition = this.state.filterSelectedCondition;
        const option = this.props.options.filter(
          obj => obj.key === selectedOption
        );

        if (option.length > 0) {
          this.props.conditionSet(this.props.data.id, {
            label:
              selectedCondition != "exact"
                ? `${selectedOption}__${selectedCondition}`
                : selectedOption,
            value: selectedValue
          });
        }
      }
    );
  };

  /** Select de condições change */
  handleConditionChange = event => {
    const value = event.target.value;

    this.setState({
      filterSelectedCondition: value,
      filterSelectedValue: ""
    });
  };

  /** Select de opções iniciais change */
  handleInitialChange = event => {
    const value = event.target.value;
    let conditions = null;

    if (value == 0 || value == "0") {
      conditions = null;
    } else {
      const key = event.target.value;
      const option = this.props.options.filter(obj => obj.key === key);

      if (option.length > 0) {
        conditions = option[0].option_type;
      }
    }

    this.setState({
      filterConditionList: conditions,
      filterSelectedOption: value,
      filterSelectedCondition: null,
      filterSelectedValue: ""
    });
  };

  translateCondition = condition => {
    // Traduz uma condição
    switch (String(condition).toLocaleLowerCase()) {
      case "gte":
        return "é maior ou igual a";
      case "lte":
        return "é menor ou igual a";
      case "iexact":
        return "é igual a";
      case "exact":
        return "é igual a";
      default:
        return "???";
    }
  };

  render() {
    const Options = this.getInicialSelect();
    const Conditions = this.getConditionSelect();
    const Field = this.getValueField();

    return (
      <div className="filter__block">
        <div className="filter__input_block">{Options}</div>
        <div className="filter__input_block">{Conditions}</div>
        <div className="filter__input_block">{Field}</div>
        <Icon
          type="minus-circle"
          className="filter__icon"
          title="Remover filtro"
          onClick={() => this.props.handleDelete(this.props.data.id)}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Filter/Condition/index.js